(function(f, g) {
    typeof exports == "object" && typeof module == "object" ? module.exports = g() : typeof define == "function" && define.amd ? define([], g) : typeof exports == "object" ? exports.axios = g() : f.axios = g()
})(window, function() {
    return function(f) {
        var g = {};
        function s(e) {
            if (g[e])
                return g[e].exports;
            var n = g[e] = {
                i: e,
                l: !1,
                exports: {}
            };
            return f[e].call(n.exports, n, n.exports, s), n.l = !0, n.exports
        }
        return s.m = f, s.c = g, s.d = function(e, n, i) {
            s.o(e, n) || Object.defineProperty(e, n, {
                enumerable: !0,
                get: i
            })
        }, s.r = function(e) {
            typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            })
        }, s.t = function(e, n) {
            if (1 & n && (e = s(e)), 8 & n || 4 & n && typeof e == "object" && e && e.__esModule)
                return e;
            var i = Object.create(null);
            if (s.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & n && typeof e != "string")
                for (var r in e)
                    s.d(i, r, function(p) {
                        return e[p]
                    }.bind(null, r));
            return i
        }, s.n = function(e) {
            var n = e && e.__esModule ? function() {
                return e.default
            } : function() {
                return e
            };
            return s.d(n, "a", n), n
        }, s.o = function(e, n) {
            return Object.prototype.hasOwnProperty.call(e, n)
        }, s.p = "", s(s.s = 10)
    }([function(f, g, s) {
        "use strict";
        var e = s(2),
            n = Object.prototype.toString;
        function i(t) {
            return n.call(t) === "[object Array]"
        }
        function r(t) {
            return t === void 0
        }
        function p(t) {
            return t !== null && typeof t == "object"
        }
        function o(t) {
            if (n.call(t) !== "[object Object]")
                return !1;
            var d = Object.getPrototypeOf(t);
            return d === null || d === Object.prototype
        }
        function a(t) {
            return n.call(t) === "[object Function]"
        }
        function u(t, d) {
            if (t != null)
                if (typeof t != "object" && (t = [t]), i(t))
                    for (var h = 0, m = t.length; h < m; h++)
                        d.call(null, t[h], h, t);
                else
                    for (var c in t)
                        Object.prototype.hasOwnProperty.call(t, c) && d.call(null, t[c], c, t)
        }
        f.exports = {
            isArray: i,
            isArrayBuffer: function(t) {
                return n.call(t) === "[object ArrayBuffer]"
            },
            isBuffer: function(t) {
                return t !== null && !r(t) && t.constructor !== null && !r(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t)
            },
            isFormData: function(t) {
                return typeof FormData != "undefined" && t instanceof FormData
            },
            isArrayBufferView: function(t) {
                return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && t.buffer instanceof ArrayBuffer
            },
            isString: function(t) {
                return typeof t == "string"
            },
            isNumber: function(t) {
                return typeof t == "number"
            },
            isObject: p,
            isPlainObject: o,
            isUndefined: r,
            isDate: function(t) {
                return n.call(t) === "[object Date]"
            },
            isFile: function(t) {
                return n.call(t) === "[object File]"
            },
            isBlob: function(t) {
                return n.call(t) === "[object Blob]"
            },
            isFunction: a,
            isStream: function(t) {
                return p(t) && a(t.pipe)
            },
            isURLSearchParams: function(t) {
                return typeof URLSearchParams != "undefined" && t instanceof URLSearchParams
            },
            isStandardBrowserEnv: function() {
                return (typeof navigator == "undefined" || navigator.product !== "ReactNative" && navigator.product !== "NativeScript" && navigator.product !== "NS") && typeof window != "undefined" && typeof document != "undefined"
            },
            forEach: u,
            merge: function t() {
                var d = {};
                function h(v, l) {
                    o(d[l]) && o(v) ? d[l] = t(d[l], v) : o(v) ? d[l] = t({}, v) : i(v) ? d[l] = v.slice() : d[l] = v
                }
                for (var m = 0, c = arguments.length; m < c; m++)
                    u(arguments[m], h);
                return d
            },
            extend: function(t, d, h) {
                return u(d, function(m, c) {
                    t[c] = h && typeof m == "function" ? e(m, h) : m
                }), t
            },
            trim: function(t) {
                return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "")
            },
            stripBOM: function(t) {
                return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t
            }
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(0),
            n = s(16),
            i = s(4),
            r = {
                "Content-Type": "application/x-www-form-urlencoded"
            };
        function p(u, t) {
            !e.isUndefined(u) && e.isUndefined(u["Content-Type"]) && (u["Content-Type"] = t)
        }
        var o,
            a = {
                transitional: {
                    silentJSONParsing: !0,
                    forcedJSONParsing: !0,
                    clarifyTimeoutError: !1
                },
                adapter: ((typeof XMLHttpRequest != "undefined" || typeof process != "undefined" && Object.prototype.toString.call(process) === "[object process]") && (o = s(5)), o),
                transformRequest: [function(u, t) {
                    return n(t, "Accept"), n(t, "Content-Type"), e.isFormData(u) || e.isArrayBuffer(u) || e.isBuffer(u) || e.isStream(u) || e.isFile(u) || e.isBlob(u) ? u : e.isArrayBufferView(u) ? u.buffer : e.isURLSearchParams(u) ? (p(t, "application/x-www-form-urlencoded;charset=utf-8"), u.toString()) : e.isObject(u) || t && t["Content-Type"] === "application/json" ? (p(t, "application/json"), function(d, h, m) {
                        if (e.isString(d))
                            try {
                                return (h || JSON.parse)(d), e.trim(d)
                            } catch (c) {
                                if (c.name !== "SyntaxError")
                                    throw c
                            }
                        return (m || JSON.stringify)(d)
                    }(u)) : u
                }],
                transformResponse: [function(u) {
                    var t = this.transitional,
                        d = t && t.silentJSONParsing,
                        h = t && t.forcedJSONParsing,
                        m = !d && this.responseType === "json";
                    if (m || h && e.isString(u) && u.length)
                        try {
                            return JSON.parse(u)
                        } catch (c) {
                            if (m)
                                throw c.name === "SyntaxError" ? i(c, this, "E_JSON_PARSE") : c
                        }
                    return u
                }],
                timeout: 0,
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
                maxContentLength: -1,
                maxBodyLength: -1,
                validateStatus: function(u) {
                    return u >= 200 && u < 300
                }
            };
        a.headers = {
            common: {
                Accept: "application/json, text/plain, */*"
            }
        }, e.forEach(["delete", "get", "head"], function(u) {
            a.headers[u] = {}
        }), e.forEach(["post", "put", "patch"], function(u) {
            a.headers[u] = e.merge(r)
        }), f.exports = a
    }, function(f, g, s) {
        "use strict";
        f.exports = function(e, n) {
            return function() {
                for (var i = new Array(arguments.length), r = 0; r < i.length; r++)
                    i[r] = arguments[r];
                return e.apply(n, i)
            }
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(0);
        function n(i) {
            return encodeURIComponent(i).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]")
        }
        f.exports = function(i, r, p) {
            if (!r)
                return i;
            var o;
            if (p)
                o = p(r);
            else if (e.isURLSearchParams(r))
                o = r.toString();
            else {
                var a = [];
                e.forEach(r, function(t, d) {
                    t != null && (e.isArray(t) ? d += "[]" : t = [t], e.forEach(t, function(h) {
                        e.isDate(h) ? h = h.toISOString() : e.isObject(h) && (h = JSON.stringify(h)), a.push(n(d) + "=" + n(h))
                    }))
                }), o = a.join("&")
            }
            if (o) {
                var u = i.indexOf("#");
                u !== -1 && (i = i.slice(0, u)), i += (i.indexOf("?") === -1 ? "?" : "&") + o
            }
            return i
        }
    }, function(f, g, s) {
        "use strict";
        f.exports = function(e, n, i, r, p) {
            return e.config = n, i && (e.code = i), e.request = r, e.response = p, e.isAxiosError = !0, e.toJSON = function() {
                return {
                    message: this.message,
                    name: this.name,
                    description: this.description,
                    number: this.number,
                    fileName: this.fileName,
                    lineNumber: this.lineNumber,
                    columnNumber: this.columnNumber,
                    stack: this.stack,
                    config: this.config,
                    code: this.code
                }
            }, e
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(0),
            n = s(17),
            i = s(18),
            r = s(3),
            p = s(19),
            o = s(22),
            a = s(23),
            u = s(6);
        f.exports = function(t) {
            return new Promise(function(d, h) {
                var m = t.data,
                    c = t.headers,
                    v = t.responseType;
                e.isFormData(m) && delete c["Content-Type"];
                var l = new XMLHttpRequest;
                if (t.auth) {
                    var x = t.auth.username || "",
                        E = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
                    c.Authorization = "Basic " + btoa(x + ":" + E)
                }
                var j = p(t.baseURL, t.url);
                function y() {
                    if (l) {
                        var b = "getAllResponseHeaders" in l ? o(l.getAllResponseHeaders()) : null,
                            w = {
                                data: v && v !== "text" && v !== "json" ? l.response : l.responseText,
                                status: l.status,
                                statusText: l.statusText,
                                headers: b,
                                config: t,
                                request: l
                            };
                        n(d, h, w), l = null
                    }
                }
                if (l.open(t.method.toUpperCase(), r(j, t.params, t.paramsSerializer), !0), l.timeout = t.timeout, "onloadend" in l ? l.onloadend = y : l.onreadystatechange = function() {
                    l && l.readyState === 4 && (l.status !== 0 || l.responseURL && l.responseURL.indexOf("file:") === 0) && setTimeout(y)
                }, l.onabort = function() {
                    l && (h(u("Request aborted", t, "ECONNABORTED", l)), l = null)
                }, l.onerror = function() {
                    h(u("Network Error", t, null, l)), l = null
                }, l.ontimeout = function() {
                    var b = "timeout of " + t.timeout + "ms exceeded";
                    t.timeoutErrorMessage && (b = t.timeoutErrorMessage), h(u(b, t, t.transitional && t.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", l)), l = null
                }, e.isStandardBrowserEnv()) {
                    var O = (t.withCredentials || a(j)) && t.xsrfCookieName ? i.read(t.xsrfCookieName) : void 0;
                    O && (c[t.xsrfHeaderName] = O)
                }
                "setRequestHeader" in l && e.forEach(c, function(b, w) {
                    m === void 0 && w.toLowerCase() === "content-type" ? delete c[w] : l.setRequestHeader(w, b)
                }), e.isUndefined(t.withCredentials) || (l.withCredentials = !!t.withCredentials), v && v !== "json" && (l.responseType = t.responseType), typeof t.onDownloadProgress == "function" && l.addEventListener("progress", t.onDownloadProgress), typeof t.onUploadProgress == "function" && l.upload && l.upload.addEventListener("progress", t.onUploadProgress), t.cancelToken && t.cancelToken.promise.then(function(b) {
                    l && (l.abort(), h(b), l = null)
                }), m || (m = null), l.send(m)
            })
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(4);
        f.exports = function(n, i, r, p, o) {
            var a = new Error(n);
            return e(a, i, r, p, o)
        }
    }, function(f, g, s) {
        "use strict";
        f.exports = function(e) {
            return !(!e || !e.__CANCEL__)
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(0);
        f.exports = function(n, i) {
            i = i || {};
            var r = {},
                p = ["url", "method", "data"],
                o = ["headers", "auth", "proxy", "params"],
                a = ["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "timeoutMessage", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "decompress", "maxContentLength", "maxBodyLength", "maxRedirects", "transport", "httpAgent", "httpsAgent", "cancelToken", "socketPath", "responseEncoding"],
                u = ["validateStatus"];
            function t(c, v) {
                return e.isPlainObject(c) && e.isPlainObject(v) ? e.merge(c, v) : e.isPlainObject(v) ? e.merge({}, v) : e.isArray(v) ? v.slice() : v
            }
            function d(c) {
                e.isUndefined(i[c]) ? e.isUndefined(n[c]) || (r[c] = t(void 0, n[c])) : r[c] = t(n[c], i[c])
            }
            e.forEach(p, function(c) {
                e.isUndefined(i[c]) || (r[c] = t(void 0, i[c]))
            }), e.forEach(o, d), e.forEach(a, function(c) {
                e.isUndefined(i[c]) ? e.isUndefined(n[c]) || (r[c] = t(void 0, n[c])) : r[c] = t(void 0, i[c])
            }), e.forEach(u, function(c) {
                c in i ? r[c] = t(n[c], i[c]) : c in n && (r[c] = t(void 0, n[c]))
            });
            var h = p.concat(o).concat(a).concat(u),
                m = Object.keys(n).concat(Object.keys(i)).filter(function(c) {
                    return h.indexOf(c) === -1
                });
            return e.forEach(m, d), r
        }
    }, function(f, g, s) {
        "use strict";
        function e(n) {
            this.message = n
        }
        e.prototype.toString = function() {
            return "Cancel" + (this.message ? ": " + this.message : "")
        }, e.prototype.__CANCEL__ = !0, f.exports = e
    }, function(f, g, s) {
        f.exports = s(11)
    }, function(f, g, s) {
        "use strict";
        var e = s(0),
            n = s(2),
            i = s(12),
            r = s(8);
        function p(a) {
            var u = new i(a),
                t = n(i.prototype.request, u);
            return e.extend(t, i.prototype, u), e.extend(t, u), t
        }
        var o = p(s(1));
        o.Axios = i, o.create = function(a) {
            return p(r(o.defaults, a))
        }, o.Cancel = s(9), o.CancelToken = s(26), o.isCancel = s(7), o.all = function(a) {
            return Promise.all(a)
        }, o.spread = s(27), o.isAxiosError = s(28), f.exports = o, f.exports.default = o
    }, function(f, g, s) {
        "use strict";
        var e = s(0),
            n = s(3),
            i = s(13),
            r = s(14),
            p = s(8),
            o = s(24),
            a = o.validators;
        function u(t) {
            this.defaults = t, this.interceptors = {
                request: new i,
                response: new i
            }
        }
        u.prototype.request = function(t) {
            typeof t == "string" ? (t = arguments[1] || {}).url = arguments[0] : t = t || {}, (t = p(this.defaults, t)).method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
            var d = t.transitional;
            d !== void 0 && o.assertOptions(d, {
                silentJSONParsing: a.transitional(a.boolean, "1.0.0"),
                forcedJSONParsing: a.transitional(a.boolean, "1.0.0"),
                clarifyTimeoutError: a.transitional(a.boolean, "1.0.0")
            }, !1);
            var h = [],
                m = !0;
            this.interceptors.request.forEach(function(y) {
                typeof y.runWhen == "function" && y.runWhen(t) === !1 || (m = m && y.synchronous, h.unshift(y.fulfilled, y.rejected))
            });
            var c,
                v = [];
            if (this.interceptors.response.forEach(function(y) {
                v.push(y.fulfilled, y.rejected)
            }), !m) {
                var l = [r, void 0];
                for (Array.prototype.unshift.apply(l, h), l = l.concat(v), c = Promise.resolve(t); l.length;)
                    c = c.then(l.shift(), l.shift());
                return c
            }
            for (var x = t; h.length;) {
                var E = h.shift(),
                    j = h.shift();
                try {
                    x = E(x)
                } catch (y) {
                    j(y);
                    break
                }
            }
            try {
                c = r(x)
            } catch (y) {
                return Promise.reject(y)
            }
            for (; v.length;)
                c = c.then(v.shift(), v.shift());
            return c
        }, u.prototype.getUri = function(t) {
            return t = p(this.defaults, t), n(t.url, t.params, t.paramsSerializer).replace(/^\?/, "")
        }, e.forEach(["delete", "get", "head", "options"], function(t) {
            u.prototype[t] = function(d, h) {
                return this.request(p(h || {}, {
                    method: t,
                    url: d,
                    data: (h || {}).data
                }))
            }
        }), e.forEach(["post", "put", "patch"], function(t) {
            u.prototype[t] = function(d, h, m) {
                return this.request(p(m || {}, {
                    method: t,
                    url: d,
                    data: h
                }))
            }
        }), f.exports = u
    }, function(f, g, s) {
        "use strict";
        var e = s(0);
        function n() {
            this.handlers = []
        }
        n.prototype.use = function(i, r, p) {
            return this.handlers.push({
                fulfilled: i,
                rejected: r,
                synchronous: !!p && p.synchronous,
                runWhen: p ? p.runWhen : null
            }), this.handlers.length - 1
        }, n.prototype.eject = function(i) {
            this.handlers[i] && (this.handlers[i] = null)
        }, n.prototype.forEach = function(i) {
            e.forEach(this.handlers, function(r) {
                r !== null && i(r)
            })
        }, f.exports = n
    }, function(f, g, s) {
        "use strict";
        var e = s(0),
            n = s(15),
            i = s(7),
            r = s(1);
        function p(o) {
            o.cancelToken && o.cancelToken.throwIfRequested()
        }
        f.exports = function(o) {
            return p(o), o.headers = o.headers || {}, o.data = n.call(o, o.data, o.headers, o.transformRequest), o.headers = e.merge(o.headers.common || {}, o.headers[o.method] || {}, o.headers), e.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function(a) {
                delete o.headers[a]
            }), (o.adapter || r.adapter)(o).then(function(a) {
                return p(o), a.data = n.call(o, a.data, a.headers, o.transformResponse), a
            }, function(a) {
                return i(a) || (p(o), a && a.response && (a.response.data = n.call(o, a.response.data, a.response.headers, o.transformResponse))), Promise.reject(a)
            })
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(0),
            n = s(1);
        f.exports = function(i, r, p) {
            var o = this || n;
            return e.forEach(p, function(a) {
                i = a.call(o, i, r)
            }), i
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(0);
        f.exports = function(n, i) {
            e.forEach(n, function(r, p) {
                p !== i && p.toUpperCase() === i.toUpperCase() && (n[i] = r, delete n[p])
            })
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(6);
        f.exports = function(n, i, r) {
            var p = r.config.validateStatus;
            r.status && p && !p(r.status) ? i(e("Request failed with status code " + r.status, r.config, null, r.request, r)) : n(r)
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(0);
        f.exports = e.isStandardBrowserEnv() ? {
            write: function(n, i, r, p, o, a) {
                var u = [];
                u.push(n + "=" + encodeURIComponent(i)), e.isNumber(r) && u.push("expires=" + new Date(r).toGMTString()), e.isString(p) && u.push("path=" + p), e.isString(o) && u.push("domain=" + o), a === !0 && u.push("secure"), document.cookie = u.join("; ")
            },
            read: function(n) {
                var i = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
                return i ? decodeURIComponent(i[3]) : null
            },
            remove: function(n) {
                this.write(n, "", Date.now() - 864e5)
            }
        } : {
            write: function() {},
            read: function() {
                return null
            },
            remove: function() {}
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(20),
            n = s(21);
        f.exports = function(i, r) {
            return i && !e(r) ? n(i, r) : r
        }
    }, function(f, g, s) {
        "use strict";
        f.exports = function(e) {
            return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e)
        }
    }, function(f, g, s) {
        "use strict";
        f.exports = function(e, n) {
            return n ? e.replace(/\/+$/, "") + "/" + n.replace(/^\/+/, "") : e
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(0),
            n = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
        f.exports = function(i) {
            var r,
                p,
                o,
                a = {};
            return i && e.forEach(i.split("\n"), function(u) {
                if (o = u.indexOf(":"), r = e.trim(u.substr(0, o)).toLowerCase(), p = e.trim(u.substr(o + 1)), r) {
                    if (a[r] && n.indexOf(r) >= 0)
                        return;
                    a[r] = r === "set-cookie" ? (a[r] ? a[r] : []).concat([p]) : a[r] ? a[r] + ", " + p : p
                }
            }), a
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(0);
        f.exports = e.isStandardBrowserEnv() ? function() {
            var n,
                i = /(msie|trident)/i.test(navigator.userAgent),
                r = document.createElement("a");
            function p(o) {
                var a = o;
                return i && (r.setAttribute("href", a), a = r.href), r.setAttribute("href", a), {
                    href: r.href,
                    protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
                    host: r.host,
                    search: r.search ? r.search.replace(/^\?/, "") : "",
                    hash: r.hash ? r.hash.replace(/^#/, "") : "",
                    hostname: r.hostname,
                    port: r.port,
                    pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
                }
            }
            return n = p(window.location.href), function(o) {
                var a = e.isString(o) ? p(o) : o;
                return a.protocol === n.protocol && a.host === n.host
            }
        }() : function() {
            return !0
        }
    }, function(f, g, s) {
        "use strict";
        var e = s(25),
            n = {};
        ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(o, a) {
            n[o] = function(u) {
                return typeof u === o || "a" + (a < 1 ? "n " : " ") + o
            }
        });
        var i = {},
            r = e.version.split(".");
        function p(o, a) {
            for (var u = a ? a.split(".") : r, t = o.split("."), d = 0; d < 3; d++) {
                if (u[d] > t[d])
                    return !0;
                if (u[d] < t[d])
                    return !1
            }
            return !1
        }
        n.transitional = function(o, a, u) {
            var t = a && p(a);
            function d(h, m) {
                return "[Axios v" + e.version + "] Transitional option '" + h + "'" + m + (u ? ". " + u : "")
            }
            return function(h, m, c) {
                if (o === !1)
                    throw new Error(d(m, " has been removed in " + a));
                return t && !i[m] && (i[m] = !0, console.warn(d(m, " has been deprecated since v" + a + " and will be removed in the near future"))), !o || o(h, m, c)
            }
        }, f.exports = {
            isOlderVersion: p,
            assertOptions: function(o, a, u) {
                if (typeof o != "object")
                    throw new TypeError("options must be an object");
                for (var t = Object.keys(o), d = t.length; d-- > 0;) {
                    var h = t[d],
                        m = a[h];
                    if (m) {
                        var c = o[h],
                            v = c === void 0 || m(c, h, o);
                        if (v !== !0)
                            throw new TypeError("option " + h + " must be " + v)
                    } else if (u !== !0)
                        throw Error("Unknown option " + h)
                }
            },
            validators: n
        }
    }, function(f) {
        f.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.js","unpkg":"dist/axios.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.js","threshold":"5kB"}]}')
    }, function(f, g, s) {
        "use strict";
        var e = s(9);
        function n(i) {
            if (typeof i != "function")
                throw new TypeError("executor must be a function.");
            var r;
            this.promise = new Promise(function(o) {
                r = o
            });
            var p = this;
            i(function(o) {
                p.reason || (p.reason = new e(o), r(p.reason))
            })
        }
        n.prototype.throwIfRequested = function() {
            if (this.reason)
                throw this.reason
        }, n.source = function() {
            var i;
            return {
                token: new n(function(r) {
                    i = r
                }),
                cancel: i
            }
        }, f.exports = n
    }, function(f, g, s) {
        "use strict";
        f.exports = function(e) {
            return function(n) {
                return e.apply(null, n)
            }
        }
    }, function(f, g, s) {
        "use strict";
        f.exports = function(e) {
            return typeof e == "object" && e.isAxiosError === !0
        }
    }])
});
//# sourceMappingURL=/s/files/1/0585/9508/2429/t/11/assets/axios.js.map?v=17551632658591404354

